import "./Login.scss";

import LoadingIcon from "components/Loading/LoadingIcon.tsx";
import { useEffect } from "react";
import { Navigate } from "react-router-dom";

import { useAuth0 } from "@auth0/auth0-react";

const Login = () => {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();

  useEffect(() => {
    if (!isAuthenticated && !isLoading) {
      loginWithRedirect();
    }
  }, [isAuthenticated, isLoading, loginWithRedirect]);

  if (isLoading) {
    return (
      <div className="Login">
        <LoadingIcon />
      </div>
    );
  }

  return isAuthenticated === true && <Navigate to="/" replace />;
};

export default Login;
